import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchPhantoms, createPhantom, deletePhantom } from '../api/phantoms';

export function usePhantoms() {
  return useQuery({
    queryKey: ['phantoms'],
    queryFn: fetchPhantoms,
    refetchInterval: 10000,
    staleTime: 5000
  });
}

export function useCreatePhantom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createPhantom,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['phantoms'] });
      qc.invalidateQueries({ queryKey: ['projects', 'bobins-state'] });
    }
  });
}

export function useDeletePhantom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deletePhantom,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['phantoms'] });
      qc.invalidateQueries({ queryKey: ['projects', 'bobins-state'] });
    }
  });
}
